import type { AppDispatch, RootState } from '@/shared/store'
import { storiesUpdate } from '@/shared/api/generated/stories/stories'
import { setStoryTitle } from '../editorSyncSlice'

/**
 * Rename the current story: call the API and revert Redux title on failure.
 */
export const renameStory = (
  payload: { title: string },
) => async (dispatch: AppDispatch, getState: () => RootState): Promise<void> => {
  const { title } = payload
  const state = getState()
  const { storyId, storyTitle: previousTitle } = state.editor.sync

  if (!storyId) return

  try {
    await storiesUpdate(storyId, { title })
  } catch {
    if (previousTitle !== null) {
      dispatch(setStoryTitle(previousTitle))
    }
  }
}
